// // import React, { useState } from 'react';
// // import { useLocation, useNavigate } from 'react-router-dom';
// // import axios from 'axios';
// // import {
// //   Box,
// //   Typography,
// //   Container,
// //   Card,
// //   CardContent,
// //   Button,
// //   CircularProgress,
// //   Alert,
// // } from '@mui/material';
// // import { Description as FileIcon } from '@mui/icons-material';
// // import { motion } from 'framer-motion';

// // const cardVariants = {
// //   hidden: { opacity: 0, y: 20 },
// //   visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
// // };

// // const ResourceDetailsScreen = () => {
// //   const navigate = useNavigate();
// //   const { state } = useLocation();
// //   const { resource } = state || {};
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState('');

// //   const downloadFile = async () => {
// //     try {
// //       setLoading(true);
// //       setError('');

// //       if (!resource?._id) {
// //         throw new Error('Resource information is incomplete');
// //       }

// //       const apiUrl = `https://kidsm.vercel.app/api/schools/teacher-resources/download/${resource._id}`;
// //       const response = await axios.get(apiUrl, {
// //         timeout: 15000,
// //         headers: {
// //           'Accept': 'application/json',
// //           'Content-Type': 'application/json',
// //         },
// //       });

// //       if (!response.data?.success || !response.data?.url) {
// //         throw new Error(response.data?.message || 'No download URL provided');
// //       }

// //       const downloadUrl = response.data.url;
// //       const fileExtension = response.data.fileType || 'pdf';
// //       const fileName = `${resource.title.replace(/[^a-zA-Z0-9\s\-_.]/g, '')}.${fileExtension}`;

// //       // Trigger browser download
// //       const link = document.createElement('a');
// //       link.href = downloadUrl;
// //       link.download = fileName;
// //       document.body.appendChild(link);
// //       link.click();
// //       document.body.removeChild(link);

// //       // Optional: Notify user
// //       alert('Download started successfully!');
// //     } catch (error) {
// //       console.error('Download failed:', error);
// //       setError(error.message || 'Failed to download resource');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   if (!resource) {
// //     return (
// //       <Box
// //         sx={{
// //           minHeight: '100vh',
// //           display: 'flex',
// //           flexDirection: 'column',
// //           alignItems: 'center',
// //           justifyContent: 'center',
// //           bgcolor: '#f5f5f5',
// //         }}
// //       >
// //         <Typography color="error">No resource data available</Typography>
// //       </Box>
// //     );
// //   }

// //   return (
// //     <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5', pt: 8 }}>
// //       <Container maxWidth="md" sx={{ py: 4 }}>
// //         <motion.div variants={cardVariants} initial="hidden" animate="visible">
// //           <Card sx={{ borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
// //             <CardContent>
// //               <Box display="flex" alignItems="center" mb={2}>
// //                 <FileIcon sx={{ color: '#6200ee', mr: 2, fontSize: 30 }} />
// //                 <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#333' }}>
// //                   {resource.title}
// //                 </Typography>
// //               </Box>
// //               <Typography sx={{ fontSize: '16px', color: '#555', mb: 1 }}>
// //                 <strong>Class:</strong> {resource.class}
// //               </Typography>
// //               <Typography sx={{ fontSize: '16px', color: '#555', mb: 1 }}>
// //                 <strong>Subject:</strong> {resource.subject}
// //               </Typography>
// //               <Typography sx={{ fontSize: '16px', color: '#555', mb: 1 }}>
// //                 <strong>Type:</strong> {resource.fileType}
// //               </Typography>
// //               {resource.fileSize && (
// //                 <Typography sx={{ fontSize: '16px', color: '#555', mb: 1 }}>
// //                   <strong>Size:</strong> {(resource.fileSize / 1024 / 1024).toFixed(2)} MB
// //                 </Typography>
// //               )}
// //               {resource.description && (
// //                 <Typography sx={{ fontSize: '14px', color: '#666', mt: 2, fontStyle: 'italic' }}>
// //                   {resource.description}
// //                 </Typography>
// //               )}
// //             </CardContent>
// //           </Card>

// //           {error && (
// //             <Alert severity="error" sx={{ mt: 2, borderRadius: '10px' }}>
// //               {error}
// //             </Alert>
// //           )}

// //           <Box mt={3} textAlign="center">
// //             <Button
// //               variant="contained"
// //               color="primary"
// //               startIcon={<FileIcon />}
// //               onClick={downloadFile}
// //               disabled={loading}
// //               sx={{ borderRadius: '8px', px: 4 }}
// //             >
// //               {loading ? 'Downloading...' : 'Download Resource'}
// //             </Button>
// //           </Box>
// //         </motion.div>
// //       </Container>
// //     </Box>
// //   );
// // };

// // export default ResourceDetailsScreen;

// import React, { useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import axios from "axios";
// import {
//   Box,
//   Typography,
//   Container,
//   Card,
//   CardContent,
//   Button,
//   CircularProgress,
//   Alert,
// } from "@mui/material";
// import { Description as FileIcon } from "@mui/icons-material";
// import { motion } from "framer-motion";

// const cardVariants = {
//   hidden: { opacity: 0, y: 20 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
// };

// const ResourceDetailsScreen = () => {
//   const navigate = useNavigate();
//   const { state } = useLocation();
//   const { resource } = state || {};
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const downloadFile = async () => {
//     try {
//       setLoading(true);
//       setError("");

//       if (!resource?._id) {
//         throw new Error("Resource information is incomplete");
//       }

//       // First get the download URL
//       // const urlResponse = await axios.get(
//       //   `https://kidsm.vercel.app/api/schools/teacher-resources/download-url/${resource._id}`,
//       //   {
//       //     timeout: 15000,
//       //   }
//       // );
//       // To this:
//       const urlResponse = await axios.get(
//         `https://kidsm.vercel.app/api/schools/teacher-resources/download/${resource._id}`,
//         {
//           timeout: 15000,
//         }
//       );

//       if (!urlResponse.data?.success || !urlResponse.data?.url) {
//         throw new Error(
//           urlResponse.data?.message || "No download URL provided"
//         );
//       }

//       const downloadUrl = urlResponse.data.url;
//       const fileExtension =
//         resource.fileType || urlResponse.data.fileType || "pdf";
//       const fileName = `${resource.title.replace(
//         /[^a-zA-Z0-9\s\-_.]/g,
//         ""
//       )}.${fileExtension}`;

//       // For Cloudinary URLs, we can directly download
//       if (downloadUrl.includes("cloudinary.com")) {
//         // Create a hidden anchor tag to trigger download
//         const link = document.createElement("a");
//         link.href = downloadUrl;
//         link.setAttribute("download", fileName);
//         link.setAttribute("target", "_blank");
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//       } else {
//         // For non-Cloudinary URLs, use fetch to get the file
//         const response = await fetch(downloadUrl);
//         if (!response.ok) {
//           throw new Error(`Failed to fetch file: ${response.statusText}`);
//         }

//         const blob = await response.blob();
//         const blobUrl = window.URL.createObjectURL(blob);

//         const link = document.createElement("a");
//         link.href = blobUrl;
//         link.setAttribute("download", fileName);
//         document.body.appendChild(link);
//         link.click();

//         // Clean up
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(blobUrl);
//       }
//     } catch (error) {
//       console.error("Download failed:", error);
//       setError(
//         error.message || "Failed to download resource. Please try again."
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (!resource) {
//     return (
//       <Box
//         sx={{
//           minHeight: "100vh",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "center",
//           bgcolor: "#f5f5f5",
//         }}
//       >
//         <Typography color="error">No resource data available</Typography>
//         <Button variant="contained" sx={{ mt: 2 }} onClick={() => navigate(-1)}>
//           Go Back
//         </Button>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ minHeight: "100vh", bgcolor: "#f5f5f5", pt: 8 }}>
//       <Container maxWidth="md" sx={{ py: 4 }}>
//         <motion.div variants={cardVariants} initial="hidden" animate="visible">
//           <Card
//             sx={{
//               borderRadius: "10px",
//               boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//             }}
//           >
//             <CardContent>
//               <Box display="flex" alignItems="center" mb={2}>
//                 <FileIcon sx={{ color: "#6200ee", mr: 2, fontSize: 30 }} />
//                 <Typography
//                   variant="h4"
//                   sx={{ fontWeight: "bold", color: "#333" }}
//                 >
//                   {resource.title}
//                 </Typography>
//               </Box>

//               <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 2 }}>
//                 <Typography sx={{ fontSize: "16px", color: "#555" }}>
//                   <strong>Class:</strong> {resource.class}
//                 </Typography>
//                 <Typography sx={{ fontSize: "16px", color: "#555" }}>
//                   <strong>Subject:</strong> {resource.subject}
//                 </Typography>
//                 <Typography sx={{ fontSize: "16px", color: "#555" }}>
//                   <strong>Type:</strong>{" "}
//                   {resource.fileType?.toUpperCase() || "FILE"}
//                 </Typography>
//                 {resource.fileSize && (
//                   <Typography sx={{ fontSize: "16px", color: "#555" }}>
//                     <strong>Size:</strong>{" "}
//                     {(resource.fileSize / 1024 / 1024).toFixed(2)} MB
//                   </Typography>
//                 )}
//               </Box>

//               {resource.description && (
//                 <Box
//                   sx={{
//                     backgroundColor: "#f9f9f9",
//                     p: 2,
//                     borderRadius: "8px",
//                     borderLeft: "4px solid #6200ee",
//                   }}
//                 >
//                   <Typography sx={{ fontSize: "14px", color: "#666" }}>
//                     {resource.description}
//                   </Typography>
//                 </Box>
//               )}
//             </CardContent>
//           </Card>

//           {error && (
//             <Alert
//               severity="error"
//               sx={{ mt: 2, borderRadius: "10px" }}
//               onClose={() => setError("")}
//             >
//               {error}
//             </Alert>
//           )}

//           <Box mt={3} textAlign="center">
//             <Button
//               variant="contained"
//               color="primary"
//               startIcon={
//                 loading ? (
//                   <CircularProgress size={20} color="inherit" />
//                 ) : (
//                   <FileIcon />
//                 )
//               }
//               onClick={downloadFile}
//               disabled={loading}
//               sx={{
//                 borderRadius: "8px",
//                 px: 4,
//                 minWidth: 200,
//               }}
//             >
//               {loading ? "Downloading..." : "Download Resource"}
//             </Button>

//             <Button
//               variant="outlined"
//               color="primary"
//               sx={{
//                 borderRadius: "8px",
//                 px: 4,
//                 minWidth: 200,
//                 ml: 2,
//               }}
//               onClick={() => navigate(-1)}
//             >
//               Go Back
//             </Button>
//           </Box>
//         </motion.div>
//       </Container>
//     </Box>
//   );
// };

// export default ResourceDetailsScreen;

// ResourceDetailsScreen.js
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Box,
  Typography,
  Container,
  Card,
  CardContent,
  Button,
  CircularProgress,
  Alert,
  Dialog,
  DialogContent,
  IconButton,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import {
  Description as FileIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import { motion } from "framer-motion";

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

const ResourceDetailsScreen = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { resource } = state || {};
  const [loading, setLoading] = useState(false);
  const [viewLoading, setViewLoading] = useState(false);
  const [error, setError] = useState("");
  const [viewerOpen, setViewerOpen] = useState(false);
  const [documentUrl, setDocumentUrl] = useState("");
  const [unsupportedFormat, setUnsupportedFormat] = useState(false);

  const supportedFormats = ["pdf", "jpg", "jpeg", "png", "gif"];

  const openDocumentViewer = async () => {
    try {
      setViewLoading(true);
      setError("");
      setUnsupportedFormat(false);

      if (!resource?._id) {
        throw new Error("Resource information is incomplete");
      }

      // Check if format is supported
      const fileExt = resource.fileType?.toLowerCase();
      if (!fileExt || !supportedFormats.includes(fileExt)) {
        setUnsupportedFormat(true);
        return;
      }

      const response = await axios.get(
        `https://kidsm.vercel.app/api/schools/teacher-resources/download/${resource._id}`,
        {
          timeout: 15000,
          headers: {
            Accept: "application/json",
          },
        }
      );

      if (!response.data?.success || !response.data?.viewUrl) {
        throw new Error(response.data?.message || "No view URL provided");
      }

      setDocumentUrl(response.data.viewUrl);
      setViewerOpen(true);
    } catch (error) {
      console.error("Failed to open document:", error);
      setError(
        error.response?.data?.message ||
          error.message ||
          "Failed to open document. Please try again."
      );
    } finally {
      setViewLoading(false);
    }
  };

  // const downloadFile = async () => {
  //   try {
  //     setLoading(true);
  //     setError("");

  //     if (!resource?._id) {
  //       throw new Error("Resource information is incomplete");
  //     }

  //     const response = await axios.get(
  //       `https://kidsm.vercel.app/api/schools/teacher-resources/download/${resource._id}`,
  //       {
  //         timeout: 15000,
  //         headers: {
  //           Accept: "application/json",
  //         },
  //       }
  //     );

  //     if (!response.data?.success || !response.data?.downloadUrl) {
  //       throw new Error(response.data?.message || "No download URL provided");
  //     }

  //     const fileExtension = response.data.fileType?.toLowerCase() || "pdf";
  //     const fileName = `${resource.title.replace(/[^a-zA-Z0-9\s\-_.]/g, "")}.${fileExtension}`;

  //     // Fetch the file as a blob
  //     const fileResponse = await axios.get(response.data.downloadUrl, {
  //       responseType: "blob",
  //       headers: {
  //         Accept: response.data.mimeType || "application/octet-stream",
  //       },
  //     });

  //     if (!fileResponse.data || fileResponse.data.size === 0) {
  //       throw new Error("Downloaded file is empty");
  //     }

  //     // Trigger download
  //     const blobUrl = window.URL.createObjectURL(new Blob([fileResponse.data]));
  //     const link = document.createElement("a");
  //     link.href = blobUrl;
  //     link.setAttribute("download", fileName);
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     window.URL.revokeObjectURL(blobUrl);

  //     alert("Download started successfully!");
  //   } catch (error) {
  //     console.error("Download failed:", error);
  //     setError(
  //       error.response?.data?.message ||
  //         error.message ||
  //         "Failed to download resource. Please try again."
  //     );
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const downloadFile = async () => {
  //   try {
  //     setLoading(true);
  //     setError("");

  //     if (!resource?._id) {
  //       throw new Error("Resource information is incomplete");
  //     }

  //     const response = await axios.get(
  //       `https://kidsm.vercel.app/api/schools/teacher-resources/download/${resource._id}`,
  //       {
  //         timeout: 15000,
  //         headers: {
  //           Accept: "application/json",
  //         },
  //       }
  //     );

  //     if (!response.data?.success || !response.data?.downloadUrl) {
  //       throw new Error(response.data?.message || "No download URL provided");
  //     }

  //     const fileExtension = resource.fileType?.toLowerCase() || "file";
  //     const fileName = `${resource.title.replace(/[^a-zA-Z0-9\s\-_.]/g, "")}${resource.resourceType === "raw" ? "" : `.${fileExtension}`}`;

  //     const link = document.createElement("a");
  //     link.href = response.data.downloadUrl;
  //     link.setAttribute("download", fileName);
  //     link.setAttribute("target", "_blank");
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   } catch (error) {
  //     console.error("Download failed:", error);
  //     setError(error.message || "Failed to download resource. Please try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const downloadFile = async () => {
    try {
      setLoading(true);
      setError("");

      if (!resource?._id) {
        throw new Error("Resource information is incomplete");
      }

      // Get the download URL from your API
      const response = await axios.get(
        `https://kidsm.vercel.app/api/schools/teacher-resources/download/${resource._id}`,
        {
          timeout: 15000,
          headers: {
            Accept: "application/json",
          },
        }
      );

      if (!response.data?.success || !response.data?.downloadUrl) {
        throw new Error(response.data?.message || "No download URL provided");
      }

      // Create a proper filename with extension
      const fileExt = resource.fileType?.toLowerCase() || "";
      const fileName = `${resource.title.replace(/[^a-zA-Z0-9\s\-_.]/g, "")}${
        fileExt ? `.${fileExt}` : ""
      }`;

      // Create a temporary anchor element to trigger download
      const link = document.createElement("a");
      link.href = response.data.downloadUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed:", error);
      setError(
        error.message || "Failed to download resource. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  // Clean up object URLs when component unmounts
  useEffect(() => {
    return () => {
      if (documentUrl) {
        URL.revokeObjectURL(documentUrl);
      }
    };
  }, [documentUrl]);

  if (!resource) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#f5f5f5",
        }}
      >
        <Typography color="error">No resource data available</Typography>
        <Button variant="contained" sx={{ mt: 2 }} onClick={() => navigate(-1)}>
          Go Back
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f5f5f5", pt: 8 }}>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <motion.div variants={cardVariants} initial="hidden" animate="visible">
          <Card
            sx={{
              borderRadius: "10px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          >
            <CardContent>
              <Box display="flex" alignItems="center" mb={2}>
                <FileIcon sx={{ color: "#6200ee", mr: 2, fontSize: 30 }} />
                <Typography
                  variant="h4"
                  sx={{ fontWeight: "bold", color: "#333" }}
                >
                  {resource.title}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 2 }}>
                <Typography sx={{ fontSize: "16px", color: "#555" }}>
                  <strong>Class:</strong> {resource.class}
                </Typography>
                <Typography sx={{ fontSize: "16px", color: "#555" }}>
                  <strong>Subject:</strong> {resource.subject}
                </Typography>
                <Typography sx={{ fontSize: "16px", color: "#555" }}>
                  <strong>Type:</strong>{" "}
                  {resource.fileType?.toUpperCase() || "FILE"}
                </Typography>
                {resource.fileSize && (
                  <Typography sx={{ fontSize: "16px", color: "#555" }}>
                    <strong>Size:</strong>{" "}
                    {(resource.fileSize / 1024 / 1024).toFixed(2)} MB
                  </Typography>
                )}
              </Box>

              {resource.description && (
                <Box
                  sx={{
                    backgroundColor: "#f9f9f9",
                    p: 2,
                    borderRadius: "8px",
                    borderLeft: "4px solid #6200ee",
                  }}
                >
                  <Typography sx={{ fontSize: "14px", color: "#666" }}>
                    {resource.description}
                  </Typography>
                </Box>
              )}
            </CardContent>
          </Card>

          {error && (
            <Alert
              severity="error"
              sx={{ mt: 2, borderRadius: "10px" }}
              onClose={() => setError("")}
            >
              {error}
            </Alert>
          )}

          <Box
            mt={3}
            textAlign="center"
            sx={{ display: "flex", justifyContent: "center", gap: 2 }}
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={
                viewLoading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <FileIcon />
                )
              }
              onClick={openDocumentViewer}
              disabled={viewLoading}
              sx={{
                borderRadius: "8px",
                px: 4,
                minWidth: 200,
              }}
            >
              View Document
            </Button>

            <Button
              variant="outlined"
              color="primary"
              startIcon={
                loading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <FileIcon />
                )
              }
              onClick={downloadFile}
              disabled={loading}
              sx={{
                borderRadius: "8px",
                px: 4,
                minWidth: 200,
              }}
            >
              Download
            </Button>
          </Box>

          <Box mt={2} textAlign="center">
            <Button
              variant="text"
              color="primary"
              onClick={() => navigate(-1)}
              sx={{
                borderRadius: "8px",
                px: 4,
              }}
            >
              Go Back
            </Button>
          </Box>
        </motion.div>
      </Container>

      {/* Document Viewer Dialog */}
      <Dialog
        open={viewerOpen}
        onClose={() => setViewerOpen(false)}
        fullWidth
        maxWidth="md"
        fullScreen={false}
      >
        <DialogTitle>
          {resource.title}
          <IconButton
            aria-label="close"
            onClick={() => setViewerOpen(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            height: "80vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {documentUrl && (
            <>
              {resource.fileType?.toLowerCase() === "pdf" ? (
                <iframe
                  src={documentUrl}
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  title="Document Viewer"
                />
              ) : ["jpg", "jpeg", "png", "gif"].includes(
                  resource.fileType?.toLowerCase()
                ) ? (
                <img
                  src={documentUrl}
                  alt={resource.title}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <Typography>This file format cannot be previewed.</Typography>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setViewerOpen(false)}>Close</Button>
          <Button onClick={downloadFile}>Download</Button>
        </DialogActions>
      </Dialog>

      {/* Unsupported Format Dialog */}
      <Dialog
        open={unsupportedFormat}
        onClose={() => setUnsupportedFormat(false)}
      >
        <DialogTitle>Unsupported Format</DialogTitle>
        <DialogContent>
          <Typography>
            The document format ({resource.fileType}) is not supported for
            preview. Please download the file to view it.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setUnsupportedFormat(false)}>Cancel</Button>
          <Button onClick={downloadFile}>Download</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ResourceDetailsScreen;
